export interface NavLink {
  label: string;
  href?: string;
  desc?: string;
  status?: string;
  date?: string;
  external?: boolean;
  locked?: boolean;
  featured?: FeaturedBlock;
}

export interface NavCard {
  name: string;
  icon?: string;
  image?: string;
  href?: string;
  desc?: string;
}

export interface FeaturedBlock {
  title: string;
  // 板块标题的跳转地址（如分类介绍页），未设置时回退到菜单首页
  href?: string;
  // cards：图片卡片网格（默认）；text：纯文字条目网格（如 AIOT 技术能力）
  display?: 'cards' | 'text';
  cards: NavCard[];
}

export interface NavColumn {
  title: string;
  links: NavLink[];
}

export interface NavMenu {
  label: string;
  href: string;
  // cards：保留产品图片卡片（仅「产品技术」菜单）；text：纯文字多列排版（其余菜单）
  variant?: 'cards' | 'text';
  // horizontal：分类条目横向平铺（用于解决方案，避免与右侧板块重复）
  layout?: 'columns' | 'horizontal';
  category?: {
    title: string;
    links: NavLink[];
  };
  featured?: FeaturedBlock;
  // columns：三列横向文字排版（用于「客户案例」）
  columns?: NavColumn[];
}

// 顶部右侧唯一高优先级按钮：项目演示
export const contactNav: NavLink = {
  label: '项目演示',
  href: '/demo',
};

// 桌面导航：首页单独作为一级入口；Logo 仅作品牌展示，不再跳转首页
export const desktopNav: (NavLink | NavMenu)[] = [
  {
    label: '首页',
    href: '/',
  },
  {
    label: '产品技术',
    href: '/products',
    variant: 'cards',
    category: {
      title: '智慧停车产品',
      links: [
        {
          label: '路内停车设备',
          href: '/products',
          desc: '路内泊位感知与识别终端',
          featured: {
            title: '路内停车设备',
            href: '/products',
            cards: [
              {
                name: 'LORA车辆探测器',
                icon: 'ri-radar-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
              },
              {
                name: 'NB-IOT车辆探测器',
                icon: 'ri-radar-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
              },
              {
                name: '网关',
                icon: 'ri-router-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692587.png',
              },
              {
                name: 'PDA手持终端',
                icon: 'ri-smartphone-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692589.png',
              },
              {
                name: '车载卡',
                icon: 'ri-bank-card-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692590.png',
              },
              {
                name: 'RFID读卡器',
                icon: 'ri-scan-2-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692591.png',
              },
              {
                name: 'RFID雷达探测读卡器',
                icon: 'ri-radar-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692586.png',
              },
              {
                name: 'AI智能停车视频取证巡检终端',
                icon: 'ri-camera-3-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/52330980.png',
              },
            ],
          },
        },
        {
          label: '停车场设备',
          href: '/products',
          desc: '车场通道控制与引导设备',
          featured: {
            title: '停车场设备',
            href: '/products',
            cards: [
              {
                name: '高速道闸',
                icon: 'ri-roadster-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693318.png',
              },
              {
                name: '车牌识别一体机',
                icon: 'ri-camera-3-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693317.png',
              },
              {
                name: '显示屏幕',
                icon: 'ri-tv-2-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24696576.png',
              },
              {
                name: '补光灯',
                icon: 'ri-flashlight-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693316.png',
              },
              {
                name: '车位锁',
                icon: 'ri-lock-2-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693321.png',
              },
              {
                name: '诱导屏',
                icon: 'ri-signpost-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24693320.png',
              },
              {
                name: '吊顶式车辆探测器',
                icon: 'ri-radar-line',
                href: '/products',
                image:
                  'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692585.png',
              },
            ],
          },
        },
      ],
    },
    featured: {
      title: '路内停车设备',
      href: '/products',
      cards: [
        {
          name: 'LORA车辆探测器',
          icon: 'ri-radar-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
        },
        {
          name: 'NB-IOT车辆探测器',
          icon: 'ri-radar-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692584.png',
        },
        {
          name: '网关',
          icon: 'ri-router-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692587.png',
        },
        {
          name: 'PDA手持终端',
          icon: 'ri-smartphone-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692589.png',
        },
        {
          name: '车载卡',
          icon: 'ri-bank-card-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692590.png',
        },
        {
          name: 'RFID读卡器',
          icon: 'ri-scan-2-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692591.png',
        },
        {
          name: 'RFID雷达探测读卡器',
          icon: 'ri-radar-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/24692586.png',
        },
        {
          name: 'AI智能停车视频取证巡检终端',
          icon: 'ri-camera-3-line',
          href: '/products',
          image:
            'https://img.wanwang.xin/contents/sitefiles2047/10236310/images/52330980.png',
        },
      ],
    },
  },
  {
    label: '解决方案',
    href: '/solutions',
    layout: 'horizontal',
    category: {
      title: '方案与咨询',
      links: [
        { label: '智慧农业', href: '/solutions/smart-agriculture', desc: '精准种植与农田数字化' },
        { label: '自由流停车', href: '/solutions/smart-parking', desc: '不停车通行 · 全场景一张网' },
        { label: '智慧餐饮', href: '/solutions/smart-catering', desc: '门店数字化与厨房协同' },
        { label: '智慧物流', href: '/solutions/smart-logistics', desc: '仓储运输与配送数字化' },
      ],
    },
    featured: {
      title: '智慧解决方案',
      cards: [
        {
          name: '自由流停车',
          icon: 'ri-parking-box-line',
          href: '/solutions/smart-parking',
          desc: '停车场通行与运营',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20smart%20parking%20lot%20with%20digital%20guidance%20screens%20and%20connected%20sensors%20showing%20available%20parking%20spaces%2C%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-sol-parking-02&orientation=landscape',
        },
        {
          name: '智慧餐饮',
          icon: 'ri-restaurant-line',
          href: '/solutions/smart-catering',
          desc: '餐厅经营与后厨协同',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20smart%20restaurant%20digital%20ordering%20system%20with%20tablet%20menu%20and%20connected%20kitchen%20automation%20concept%2C%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-sol-dining-03&orientation=landscape',
        },
        {
          name: '智慧农业',
          icon: 'ri-plant-line',
          href: '/solutions/smart-agriculture',
          desc: '精准种植与农田数字化',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20smart%20farm%20concept%20with%20neat%20crop%20field%20rows%20and%20connected%20IoT%20sensor%20devices%20displaying%20growth%20data%20panels%2C%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-sol-farm-05&orientation=landscape',
        },
      ],
    },
  },
  {
    label: '客户案例',
    href: '/cases',
    columns: [
      {
        title: '客户案例',
        links: [
          { label: '九畴云市项目', href: '/jiuchou', desc: '核心战略项目' },
          { label: '敬龙国际「味聚」项目', href: '/weiju' },
          { label: '铼停科技自由流停车', href: '/cases/lieting-smart-parking', desc: '自由流停车解决方案' },
          { label: '帝星咖啡', href: '/cases', desc: '0# 数商综合体验证场' },
          { label: '中仙数智商贸', href: '/cases/zhongxian-farm-market', desc: '智慧农场解决方案' },
          { label: 'ePin食安码', href: '/cases/epin-food-safety', desc: '一物一码溯源数字身份' },
        ],
      },
    ],
  },
  {
    label: '关于华辉',
    href: '/about/company',
    layout: 'horizontal',
    category: {
      title: '认识华辉',
      links: [
        { label: '公司', href: '/about/company', desc: '华辉数智是谁与业务角色' },
        { label: '投资关系', href: '/about/investor-relations', desc: '投资、合作与治理信息' },
        { label: '相关资料', href: '/about/resources', desc: '企业资料与可下载内容' },
      ],
    },
  },
  {
    label: '联系我们',
    href: '/contact/business',
    category: {
      title: '业务联系',
      links: [
        { label: '业务联系', href: '/contact/business', desc: '投资 · 产业 · 县域 · 政策 · 技术合作' },
      ],
    },
    featured: {
      title: '合作方向',
      cards: [
        {
          name: '投资合作',
          icon: 'ri-funds-line',
          href: '/contact/business',
          desc: '资本与项目共建',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20handshake%20and%20financial%20growth%20concept%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-contact-invest-01&orientation=landscape',
        },
        {
          name: '产业合作',
          icon: 'ri-building-4-line',
          href: '/contact/business',
          desc: '产业链协同',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20smart%20factory%20industry%20concept%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-contact-industry-02&orientation=landscape',
        },
        {
          name: '县域合作',
          icon: 'ri-map-pin-2-line',
          href: '/contact/business',
          desc: '县域数字商业',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20rural%20county%20development%20landscape%20concept%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-contact-county-03&orientation=landscape',
        },
        {
          name: '政策合作',
          icon: 'ri-scales-3-line',
          href: '/contact/business',
          desc: '政策与治理协同',
          image:
            'https://readdy.ai/api/search-image?query=Stylized%20policy%20document%20and%20scales%20of%20governance%20concept%20on%20a%20clean%20minimal%20light%20gray%20background%2C%20soft%20diffused%20lighting%2C%20editorial%20illustration%2C%20high%20detail%2C%20centered%20composition&width=480&height=240&seq=nav-contact-policy-04&orientation=landscape',
        },
      ],
    },
  },
];

// 移动端菜单：与桌面导航保持一致
// 注意：首页条目已包含在 desktopNav 中，无需重复添加
export const mobileNav: (NavLink | NavMenu)[] = [...desktopNav];